import React from 'react'

import { useStore } from 'services/store'
import { DarkModeIcon, IconWrapper, LightModeIcon, SocialMenuCenterWrapper } from './style'
/**
 * React component that renders social media menu
 */
const ThemeToggle = (): JSX.Element => {
  // handles open state
  const { isDarkMode, setDarkMode } = useStore()

  return (
    <SocialMenuCenterWrapper tabIndex={0}>
      <IconWrapper
        onClick={() => setDarkMode(!isDarkMode)}
        icon={isDarkMode ? DarkModeIcon : LightModeIcon}
      />
    </SocialMenuCenterWrapper>
  )
}
export default ThemeToggle
